<template>
    <div v-show="isActive" class="Tab" :class="{'Tab--active': isActive}">
        <slot />
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop, Inject } from 'vue-property-decorator';

    import { TABS_REGISTRY, TabsRegistry } from './types';

    @Component
    export default class Tab extends Vue {
        @Prop({ type: String, default: '' })
        public name!: string;

        @Prop({ type: String, default: '' })
        public id!: string;

        // PRODUCT-26110 Phase 2B2: self-register with the parent Tabs instead of relying
        // on the parent walking `$children` (removed in Vue 3). `isActive` is derived from
        // the parent's reactive active-tab state, so v-show updates reactively.
        @Inject({ from: TABS_REGISTRY, default: undefined })
        private tabsRegistry?: TabsRegistry;

        public get isActive(): boolean {
            return this.tabsRegistry?.activeId === this.id;
        }

        private created(): void {
            this.tabsRegistry?.register({ id: this.id, name: this.name });
        }

        private beforeUnmount(): void {
            this.tabsRegistry?.unregister(this.id);
        }
    }
</script>
